import CDCAuth from './cdc/CDCAuth';

if (window.cdc_settings) {
    window.auth = new CDCAuth(window.cdc_settings);
    // window.auth.checkIfLoggedIn();
}
